import { Dispatch, SetStateAction } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Typography, Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import ErrorIcon from 'app/components/Icons/ErrorIcon';

import SuccessIcon from '../Icons/SuccessIcon';
import { dialogContent, paperProps } from './SuccessModal.sx';

interface Props {
  open: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  successText: string;
  unsuccess?: boolean;
  sign?: any;
  closeAsan?: any;
  path?: string;
  closeWithoutRedirect?: any;
  templates?: boolean;
  closeParentModal?: any;
  title?: string;
  redirectUrl?: string;
  handleAction?: (btnType: string) => void;
  isClosedAsanModal? : boolean;
}

const SuccessModal = (props: Props) => {
  const {
    open,
    close,
    successText,
    sign,
    unsuccess,
    closeAsan,
    path,
    closeWithoutRedirect,
    templates,
    closeParentModal,
    title,
    redirectUrl,
    handleAction,
    isClosedAsanModal
  } = props;
  const location = useLocation();
  const lang = location.pathname.substring(0, 3);
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: paperProps,
      }}
      onClose={() => {
        close(false);
        closeParentModal(false);
        if (closeAsan !== undefined) {
          closeAsan(false);
        }
      }}
    >
      <DialogContent sx={dialogContent}>
        {!unsuccess ? (
          <SuccessIcon sx={{ width: '64px', height: '64px' }} />
        ) : (
          <ErrorIcon sx={{ width: '64px', height: '64px' }} />
        )}
        <Typography sx={{ fontSize: '26px', fontWeight: 600, textAlign: 'center' }}> {title ?? successText}</Typography>
        {sign ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
            <Button
              color={'primary'}
              onClick={() => {
                try {
                  handleAction('go-home');
                } catch (error) {
                  window.location.href = `${lang}/home-page`;
                  close(false);
                  if (closeAsan !== undefined) {
                    closeAsan(false);
                  }
                }
              }}
            >
              {t('commonActions.goToHomePage')}
            </Button>
            <Button
              onClick={() => {
                if (redirectUrl) {
                  window.location.href = `${lang}/${redirectUrl}`;

                  return;
                }
                try {
                  handleAction('close');
                } catch (error) {
                  if (path !== undefined) {
                    window.location.href = `${lang}/templates-page`;
                  } else {
                    window.location.href = `${lang}/transfer-page`;
                  }
                  close(false);
                }
              }}
              color={'secondary'}
            >
              {t('commonActions.close')}
            </Button>
          </Box>
        ) : templates ? (
          <Box sx={{ display: 'flex', gap: '12px' }}>
            <Button
              color={'primary'}
              onClick={() => {
                window.location.href = `${lang}/templates-page`;
                close(false);
              }}
            >
              {t('commonActions.goToTemplates')}
            </Button>
            <Button
              onClick={() => {
                close(false);
                if (closeParentModal) {
                  closeParentModal(false);
                }
              }}
              color={'secondary'}
            >
              {t('commonActions.close')}
            </Button>
          </Box>
        ) : (
          <Button
            sx={{ width: '100%' }}
            onClick={() => {
              if(isClosedAsanModal){
               closeAsan(false);

                return;
              }

              if (closeWithoutRedirect) {
                close(false);

                return;
              }
              if (redirectUrl) {
                window.location.href = `${lang}/${redirectUrl}`;

                return;
              }
              if (path === 'accounts-card') {
                window.location.href = `${lang}/accounts-card?type=accounts`;
              } else if (path === 'profile') {
                window.location.href = `${lang}/profile?type=users`;
              } else if (path === 'home-page') {
                window.location.href = `${lang}/home-page`;
              } else if (path !== undefined) {
                window.location.href = `${lang}/templates-page`;
              } else {
                window.location.href = `${lang}/transfer-page`;
              }
              close(false);
              closeParentModal(false);
            }}
            color={'secondary'}
          >
            {t('commonActions.close')}
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal;
